import { render, staticRenderFns } from "./sectionDragable.vue?vue&type=template&id=71a37412"
import script from "./sectionDragable.vue?vue&type=script&lang=js"
export * from "./sectionDragable.vue?vue&type=script&lang=js"
import style0 from "./sectionDragable.vue?vue&type=style&index=0&id=71a37412&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports